import { IpAddressPill } from '#components/atoms/pill/ip-address-pill/IpAddressPill.tsx';
import { sortIpsV6First } from '#util/hostIps.ts';

type Props = {
  /** Bare IPs or CIDRs; family is detected by presence of `:`. */
  ipAddresses: readonly string[];
};

export function IpAddressPillList({ ipAddresses }: Props) {
  return (
    <div className="flex flex-col">
      {sortIpsV6First(ipAddresses).map((ip) => (
        <IpAddressPill className="-ml-6" key={ip} ipAddress={ip} />
      ))}
    </div>
  );
}
